// Generated for VGNA: the bot's 1.0-11.0 tier float, not VGPro's 0-3000 VST.
// Ten Vainglory tiers x Bronze/Silver/Gold, matching elo.tier_parts exactly.
export default {
  "0": {
    "title": "Unranked",
    "color": "",
    "starts": -1,
    "ends": 1
  },
  "1": {
    "title": "Just Beginning",
    "color": "Bronze",
    "starts": 1.0,
    "ends": 1.25
  },
  "2": {
    "title": "Just Beginning",
    "color": "Silver",
    "starts": 1.25,
    "ends": 1.75
  },
  "3": {
    "title": "Just Beginning",
    "color": "Gold",
    "starts": 1.75,
    "ends": 2.0
  },
  "4": {
    "title": "Getting There",
    "color": "Bronze",
    "starts": 2.0,
    "ends": 2.25
  },
  "5": {
    "title": "Getting There",
    "color": "Silver",
    "starts": 2.25,
    "ends": 2.75
  },
  "6": {
    "title": "Getting There",
    "color": "Gold",
    "starts": 2.75,
    "ends": 3.0
  },
  "7": {
    "title": "Rock Solid",
    "color": "Bronze",
    "starts": 3.0,
    "ends": 3.25
  },
  "8": {
    "title": "Rock Solid",
    "color": "Silver",
    "starts": 3.25,
    "ends": 3.75
  },
  "9": {
    "title": "Rock Solid",
    "color": "Gold",
    "starts": 3.75,
    "ends": 4.0
  },
  "10": {
    "title": "Worthy Foe",
    "color": "Bronze",
    "starts": 4.0,
    "ends": 4.25
  },
  "11": {
    "title": "Worthy Foe",
    "color": "Silver",
    "starts": 4.25,
    "ends": 4.75
  },
  "12": {
    "title": "Worthy Foe",
    "color": "Gold",
    "starts": 4.75,
    "ends": 5.0
  },
  "13": {
    "title": "Got Swagger",
    "color": "Bronze",
    "starts": 5.0,
    "ends": 5.25
  },
  "14": {
    "title": "Got Swagger",
    "color": "Silver",
    "starts": 5.25,
    "ends": 5.75
  },
  "15": {
    "title": "Got Swagger",
    "color": "Gold",
    "starts": 5.75,
    "ends": 6.0
  },
  "16": {
    "title": "Credible Threat",
    "color": "Bronze",
    "starts": 6.0,
    "ends": 6.25
  },
  "17": {
    "title": "Credible Threat",
    "color": "Silver",
    "starts": 6.25,
    "ends": 6.75
  },
  "18": {
    "title": "Credible Threat",
    "color": "Gold",
    "starts": 6.75,
    "ends": 7.0
  },
  "19": {
    "title": "The Hotness",
    "color": "Bronze",
    "starts": 7.0,
    "ends": 7.25
  },
  "20": {
    "title": "The Hotness",
    "color": "Silver",
    "starts": 7.25,
    "ends": 7.75
  },
  "21": {
    "title": "The Hotness",
    "color": "Gold",
    "starts": 7.75,
    "ends": 8.0
  },
  "22": {
    "title": "Simply Amazing",
    "color": "Bronze",
    "starts": 8.0,
    "ends": 8.25
  },
  "23": {
    "title": "Simply Amazing",
    "color": "Silver",
    "starts": 8.25,
    "ends": 8.75
  },
  "24": {
    "title": "Simply Amazing",
    "color": "Gold",
    "starts": 8.75,
    "ends": 9.0
  },
  "25": {
    "title": "Pinnacle of Awesome",
    "color": "Bronze",
    "starts": 9.0,
    "ends": 9.25
  },
  "26": {
    "title": "Pinnacle of Awesome",
    "color": "Silver",
    "starts": 9.25,
    "ends": 9.75
  },
  "27": {
    "title": "Pinnacle of Awesome",
    "color": "Gold",
    "starts": 9.75,
    "ends": 10.0
  },
  "28": {
    "title": "Vainglorious",
    "color": "Bronze",
    "starts": 10.0,
    "ends": 10.25
  },
  "29": {
    "title": "Vainglorious",
    "color": "Silver",
    "starts": 10.25,
    "ends": 10.75
  },
  "30": {
    "title": "Vainglorious",
    "color": "Gold",
    "starts": 10.75,
    "ends": 11.0
  }
};
